import { defineField, defineType } from "sanity";

export const eventsPage = defineType({
  name: "eventsPage",
  title: "Events Page",
  type: "document",
  groups: [
    { name: "hero", title: "Hero", default: true },
    { name: "customEvents", title: "Custom Events" },
    { name: "subscribe", title: "Subscribe" },
    { name: "seo", title: "SEO" }
  ],
  fields: [
    defineField({
      name: "heroImage",
      title: "Hero image",
      type: "image",
      description: "Hero image at the top of the Events page.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "hero"
    }),
    defineField({
      name: "heroHeading",
      title: "Hero heading",
      type: "string",
      description: "Main heading on the events hero (e.g. 'Events & Workshops').",
      group: "hero"
    }),
    defineField({
      name: "heroSubtitle",
      title: "Hero subtitle",
      type: "string",
      description: "Subtitle below the hero heading.",
      group: "hero"
    }),
    defineField({
      name: "defaultEventImage",
      title: "Default event image",
      type: "image",
      description: "Fallback image used for event cards when no specific image is provided.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "hero"
    }),
    defineField({
      name: "customEventsHeading",
      title: "Custom events heading",
      type: "string",
      description: "Heading for the custom events CTA section.",
      group: "customEvents"
    }),
    defineField({
      name: "customEventsBody",
      title: "Custom events body",
      type: "text",
      rows: 3,
      description: "Body text for the custom events CTA section.",
      group: "customEvents"
    }),
    defineField({
      name: "customEventsCtaText",
      title: "Custom events CTA text",
      type: "string",
      description: "Button text for the custom events CTA (e.g. 'Request a Custom Event').",
      group: "customEvents"
    }),
    defineField({
      name: "customEventsCtaLink",
      title: "Custom events CTA link",
      type: "string",
      description: "Link for the custom events CTA button (e.g. /contact).",
      group: "customEvents"
    }),
    defineField({
      name: "subscribeHeading",
      title: "Subscribe heading",
      type: "string",
      description: "Heading for the subscribe section.",
      group: "subscribe"
    }),
    defineField({
      name: "subscribeBody",
      title: "Subscribe body",
      type: "text",
      rows: 2,
      description: "Body text for the subscribe section.",
      group: "subscribe"
    }),
    defineField({
      name: "subscribeButtonText",
      title: "Subscribe button text",
      type: "string",
      description: "Text on the subscribe button (e.g. 'Subscribe').",
      group: "subscribe"
    }),
    defineField({
      name: "metaTitle",
      title: "Meta title",
      type: "string",
      description: "Page title for search engines.",
      group: "seo"
    }),
    defineField({
      name: "metaDescription",
      title: "Meta description",
      type: "text",
      rows: 3,
      description: "Short description for search engines.",
      group: "seo"
    }),
    defineField({
      name: "ogImage",
      title: "Sharing image",
      type: "image",
      description: "Image shown when this page is shared on social media.",
      options: { hotspot: true },
      fields: [
        defineField({
          name: "alt",
          title: "Alt text",
          type: "string",
          description: "Describe the image for screen readers."
        })
      ],
      group: "seo"
    })
  ],
  preview: {
    prepare: () => ({
      title: "Events Page"
    })
  }
});
